import React from "react";
import { MegaMenuConfig } from "../types";
import ClinicModelsPanel from "./clinic-models";

// Map of custom component identifiers to their components
const customComponentMap: Record<
  string,
  React.ComponentType<{ menu: MegaMenuConfig }>
> = {
  "clinic-models": ClinicModelsPanel,
};

export function getCustomComponent(
  componentId: string | undefined
): React.ComponentType<{ menu: MegaMenuConfig }> | null {
  if (!componentId) return null;
  return customComponentMap[componentId] || null;
}
